export const calculateReadTime = (slices) => {
    const contentText = slices
        .filter(({ slice_type }) => slice_type === 'content')
        .map((contentSlice) => contentSlice.primary.content.text)
        .join(' ');

    const wordCount = contentText.replace(/[^\w ]/g, '').split(/\s+/).length;

    const readingTimeInMinutes = Math.floor(wordCount / 228) + 1;
    const readingTimeAsString =
        readingTimeInMinutes +
        ` ${readingTimeInMinutes === 1 ? 'min' : 'mins'}`;

    return readingTimeAsString;
};
